
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { UserMenu } from "./UserMenu";

interface AuthSectionProps {
  user: any;
  getDashboardLink: () => string;
  handleLogout: () => Promise<void>;
}

export const AuthSection = ({ user, getDashboardLink, handleLogout }: AuthSectionProps) => {
  const navigate = useNavigate();

  if (!user) {
    return (
      <Button onClick={() => navigate("/login")}>
        Sign in
      </Button>
    );
  }

  return (
    <UserMenu 
      user={user}
      getDashboardLink={getDashboardLink}
      handleLogout={handleLogout}
    />
  );
};
